const BrochureDownloadLinks = ({ pdfUrl, docUrl }) => {
    if (!pdfUrl && !docUrl) return null;

    return (
        <div className="modern-resource-brochure-links">
            {pdfUrl && (
                <a href={pdfUrl} target="_blank" rel="noopener noreferrer" download>
                    <i className="fa fa-file-pdf-o" aria-hidden="true" />
                    PDF
                </a>
            )}
            {docUrl && (
                <a href={docUrl} target="_blank" rel="noopener noreferrer" download>
                    <i className="fa fa-file-word-o" aria-hidden="true" />
                    DOC
                </a>
            )}
        </div>
    );
};

export default BrochureDownloadLinks;
